import React from 'react';
import type { IconProps } from './types';

// Agent/robot glyph used by the per-patient service status row.
const RobotIcon: React.FC<IconProps> = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="4" y="7" width="16" height="12" rx="2" />
    <path d="M12 7V3" />
    <circle cx="12" cy="3" r="1" />
    <circle cx="9" cy="13" r="1" />
    <circle cx="15" cy="13" r="1" />
    <path d="M9 17h6" />
  </svg>
);

export default RobotIcon;
